<template>
  <div>
    <template v-if="categories.results">
      <template v-if="category.id">
        <template v-if="!userData">
          <landing-page />
        </template>

        <listing-loader
          page="category"
          :category="category.id"
        />
      </template>
      <div
        v-else
        class="alert alert-danger"
        role="alert"
      >
        Category not found.
      </div>
    </template>
    <spinner
      v-else-if="categories.loading"
      preset="large"
    />
    <template v-else-if="categories.error">
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load the category. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="$store.dispatch('categories')"
      >
        Try Again
      </button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ListingLoader from '@/components/ListingLoader.vue';
import LandingPage from '@/components/LandingPage.vue';

export default {
  metaInfo() {
    let title;

    if (this.categories.results) {
      if (this.category.id) {
        title = this.category.name;
      } else {
        title = 'Category Not Found';
      }
    } else {
      title = 'Category';
    }

    return {
      title,
    };
  },
  components: {
    ListingLoader,
    LandingPage,
  },
  props: {
    categorySlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      category: {},
    };
  },
  computed: {
    ...mapState([
      'categories',
    ]),
  },
  watch: {
    categorySlug() {
      this.loadCategory();
    },
    categories: {
      immediate: true,
      handler() {
        this.loadCategory();
      },
    },
  },
  methods: {
    loadCategory() {
      if (this.categories.results) {
        const category = this.categories.results.filter(c => c.slug === this.categorySlug);

        if (category.length) {
          [this.category] = category;
        } else {
          this.category = { not_found: true };
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
};
</script>
